import { useState } from "react";
import PerfectScrollbar from "react-perfect-scrollbar";
import useSnackbar from "components/Alerts/Snackbar/useSnackbar";

import {
  Chip,
  Box,
  Button,
  Typography,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormLabel,
  TextField,
  Grid,
  FormGroup,
  LinearProgress,
} from "@material-ui/core";
import { SwapHoriz } from "@material-ui/icons";
import Api from "lib/api/httpRequestHelper";
import useLogs from "hooks/logs";

export function DialogChangeUser({ open, onClose, selectedUser, formType }) {
  const snackbar = useSnackbar();
  const { setLocalStorageActions } = useLogs();
  const userDefault = JSON.parse(localStorage.getItem("userDetail"));
  const userVision = localStorage.getItem("userVision");

  const [changing, setChanging] = useState(false);
  const [user, setUser] = useState(userVision);

  const handleClose = () => {
    onClose();
  };

  const handleChangeUser = async () => {
    setChanging(true);
    setLocalStorageActions({
      nomeTela: "Troca de Usuários",
      idMenu: "55",
      acao: "Clicou para trocar de usuário",
    });

    localStorage.removeItem("k-user-vision");
    localStorage.removeItem("userVision");
    localStorage.removeItem("sessoesMenuUserVision");
    localStorage.removeItem("viewsMenuUserVision");
    localStorage.removeItem("userDetailVision");
    localStorage.removeItem("userProfilesVision");

    if (formType === "remove") {
      localStorage.setItem("userVision", "default");
      setTimeout(() => {
        snackbar.showMessage("Usuário redefinido com sucesso.", {
          severity: "success",
        });
        setChanging(false);
        localStorage.removeItem("userVision");
        handleClose();
      }, 2000);
    } else {
      localStorage.setItem("k-user-vision", selectedUser?.IdHash);

      setTimeout(async () => {
        await Api.get("user-detail", "login", "", true)
          .then((res) => {
            localStorage.setItem("userVision", selectedUser?.Nome);
            localStorage.setItem(
              "sessoesMenuUserVision",
              JSON.stringify(res.Result.SessoesMenu || [])
            );
            localStorage.setItem(
              "viewsMenuUserVision",
              JSON.stringify(res.Result.ViewsMenu || [])
            );
            localStorage.setItem(
              "userDetailVision",
              JSON.stringify(res.Result || [])
            );
            localStorage.setItem(
              "userProfilesVision",
              JSON.stringify(res.Result.UsuarioPerfis || [])
            );
            snackbar.showMessage("Usuário alterado com sucesso.", {
              severity: "success",
            });
          })
          .catch((error) => {
            console.log(error);
          })
          .finally(() => {
            setChanging(false);
            handleClose();
          });
      }, 2000);
    }
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
      >
        <DialogTitle>
          <span>
            <Typography id="alert-dialog-title" variant="h3" component="h3">
              Confirmar{" "}
              {formType === "remove"
                ? "redefinição de usuário"
                : "alteração de usuário"}
            </Typography>
          </span>
        </DialogTitle>
        <PerfectScrollbar>
          <DialogContent style={{ padding: "1rem 1.5rem 1.5rem" }}>
            <Grid container hidden={formType === "remove"}>
              <Grid item xs={12}>
                <FormGroup>
                  <FormLabel>Nome</FormLabel>
                  <TextField
                    name="nome"
                    required
                    fullWidth
                    disabled
                    value={selectedUser?.Nome}
                    variant="outlined"
                  />
                </FormGroup>
              </Grid>
              <Grid item xs={12}>
                <FormGroup>
                  <FormLabel>Login</FormLabel>
                  <TextField
                    name="login"
                    required
                    fullWidth
                    disabled
                    value={selectedUser?.Login}
                    variant="outlined"
                  />
                </FormGroup>
              </Grid>
              <Grid item xs={12}>
                <FormGroup>
                  <FormLabel>Perfis</FormLabel>
                  <Grid item xs={12} style={{ marginLeft: "-1rem" }}>
                    {selectedUser?.UsuarioPerfis?.map((profile) => (
                      <Chip
                        key={profile?.IdPerfil}
                        style={{
                          color: profile?.Nome === "ADM" ? "white" : "#3f3f3f",
                          border: "1px solid #3f3f3f",
                          backgroundColor:
                            profile?.Nome === "ADM" ? "#3f3f3f" : "white",
                          margin: "1px 1px",
                          padding: "0.25rem 0.5rem",
                          fontSize: "11px",
                        }}
                        variant="outlined"
                        label={profile?.Nome}
                        size="small"
                      />
                    ))}
                  </Grid>
                </FormGroup>
              </Grid>
            </Grid>
            <Grid container hidden={formType === "edit"}>
              <Grid item xs={12}>
                <FormGroup>
                  <FormLabel>Usuário padrão</FormLabel>
                  <TextField
                    name="padrão"
                    required
                    fullWidth
                    disabled
                    value={userDefault?.Nome}
                    variant="outlined"
                  />
                </FormGroup>
              </Grid>
              <Grid
                item
                xs={12}
                style={{ display: "flex", justifyContent: "center" }}
              >
                <Box
                  component={SwapHoriz}
                  width="1.25rem!important"
                  height="1.25rem!important"
                />
              </Grid>
              <Grid item xs={12}>
                <FormGroup>
                  <FormLabel>Usuário atual</FormLabel>
                  <TextField
                    name="atual"
                    required
                    fullWidth
                    disabled
                    value={userVision !== "default" ? userVision : user}
                    variant="outlined"
                  />
                </FormGroup>
              </Grid>
            </Grid>
          </DialogContent>
        </PerfectScrollbar>
        <DialogActions>
          <Button component={Box} onClick={handleClose} disabled={changing}>
            Cancelar
          </Button>
          <Button
            color="default"
            variant="contained"
            onClick={handleChangeUser}
            disabled={changing}
          >
            {formType === "remove" ? "Redefinir" : "Alterar"}
          </Button>
        </DialogActions>
        {changing && (
          <Grid item xs={12}>
            <span>Alterando usuário...</span>
            <LinearProgress />
          </Grid>
        )}
      </Dialog>
    </>
  );
}
